import React, { useState } from 'react'
import { Modal, Upload, Button, List, message } from 'antd'
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons'
import myDocumentStore from '../../stores/myDocumentStore'
import { FileRequest } from '../../requests/FileRequest'
import utils from '../../utils'
import { redPrimary } from '../../color'

const UploadFileModal = ({ visible, onCancel, onSuccess, parentId }) => {
  const [fileList, setFileList] = useState([])
  const [loading, setLoading] = useState(false)

  const handleUpload = async () => {
    if (fileList.length === 0) return
    setLoading(true)
    let hasError = false
    
    for (const file of fileList) {
      try {
        const formData = new FormData()
        formData.append('file', file)
        
        const uploadRes = await FileRequest.uploadFile(formData)
        const fileData = uploadRes.data

        if (!fileData || !fileData.file_id) {
          throw new Error('Upload failed')
        }

        await myDocumentStore.createDocument({
          name: file.name,
          type: fileData.file_type || 'file',
          parentId: parentId || '',
          gridFsFileId: fileData.file_id,
          size: file.size,
          mimeType: file.type
        })
      } catch (error) {
        hasError = true
      }
    }

    setLoading(false)
    if (hasError) {
      message.error('Có lỗi xảy ra khi tải lên một số file')
    } else {
      message.success('Tải lên thành công')
      setFileList([])
      onSuccess()
    }
  }

  const props = {
    onRemove: file => {
      setFileList(prev => prev.filter(item => item.uid !== file.uid))
    },
    beforeUpload: file => {
      setFileList(prev => [...prev, file])
      return false
    },
    fileList,
    multiple: true,
  }

  return (
    <Modal
      title="Tải lên tài liệu"
      visible={visible}
      onOk={handleUpload}
      onCancel={() => {
        setFileList([])
        onCancel()
      }}
      confirmLoading={loading}
      okButtonProps={{ disabled: fileList.length === 0 }}
      okText="Tải lên"
      cancelText="Hủy"
    >
      <Upload {...props} showUploadList={false}>
        <Button icon={<UploadOutlined />}>Chọn file</Button>
      </Upload>
      <List
        size="small"
        style={{ marginTop: 16 }}
        dataSource={fileList}
        renderItem={item => (
          <List.Item
            actions={[
              <DeleteOutlined 
                style={{ color: redPrimary }} 
                onClick={() => props.onRemove(item)} 
              />
            ]}
          >
            <List.Item.Meta title={item.name} />
          </List.Item>
        )}
      />
    </Modal>
  )
}

export default UploadFileModal
